import { cn } from 'helpers/css';
import React, { useRef, useState } from 'react';

import {
  Accordion as AccordionShadcn,
  AccordionTrigger,
  AccordionContent,
  AccordionItem,
} from 'shadcn/components/accordion';

/**
 *
 * @param {Object} props
 * @param {boolean} props.openByDefault
 * @param {string} props.classNameContainer
 * @param {string} props.classNameTrigger
 * @param {string} props.classNameContent
 * @param {JSX} props.triggerRender
 * @param {JSX} props.contentRender
 * @returns
 */
const Accordion = ({
  triggerRender,
  contentRender,
  openByDefault,
  classNameContainer,
  classNameTrigger,
  classNameContent,
}) => {
  //! State
  const valueRandom = useRef(new Date().getTime());
  const [val, setVal] = useState(openByDefault ? `${valueRandom.current}` : undefined);

  //! Function

  //! Render
  return (
    <AccordionShadcn
      value={val}
      onValueChange={setVal}
      type='single'
      collapsible
      className={cn('tw-w-full', classNameContainer)}
    >
      <AccordionItem value={`${valueRandom.current}`}>
        <AccordionTrigger className={cn(classNameTrigger)}>{triggerRender}</AccordionTrigger>
        <AccordionContent className={cn(classNameContent)}>{contentRender}</AccordionContent>
      </AccordionItem>
    </AccordionShadcn>
  );
};

export default Accordion;
